import React from 'react';
import usePointerVars from '../hooks/usePointerVars';
import useMotionPrefs from '../hooks/useMotionPrefs';
import SkillTag from './SkillTag';
import { Check } from './icons';

/* ==================================================================
   StudentCard
   ------------------------------------------------------------------
   A candidate as a company sees them: track, skills, availability.
   Used on the dark "for companies" section, so its palette is set by
   the parent through CSS rather than by props.
   ================================================================== */

export default function StudentCard({ student, index = 0 }) {
  const { reduced, pointer } = useMotionPrefs();
  const ref = usePointerVars({ disabled: reduced || !pointer });

  return (
    <article ref={ref} className="hs-cand" style={{ '--hs-i': index }}>
      <header className="hs-cand__head">
        <span className={`hs-cand__avatar hs-cand__avatar--${student.tone || 'blue'}`}>
          {student.name.slice(0, 1)}
        </span>
        <div>
          <h3 className="hs-cand__name">{student.name}</h3>
          <p className="hs-cand__track">{student.track}</p>
        </div>
      </header>

      <div className="hs-cand__skills">
        {student.skills.map((skill, i) => (
          <SkillTag key={skill} tone="dark" index={i}>{skill}</SkillTag>
        ))}
      </div>

      {student.signals && (
        <ul className="hs-cand__signals">
          {student.signals.map((signal) => (
            <li key={signal}><Check /> {signal}</li>
          ))}
        </ul>
      )}
    </article>
  );
}
